import { ReactNode } from "react";

import { Footer, Navbar } from "@/components/WhiteLabelComponents";
import FindBestPriceActionBar from "@/components/FindBestPriceActionBar";
import ErrorSection from "@/components/ErrorSection";

import styles from "./WhiteLabelLayout.module.scss";

interface LayoutProps {
  children: ReactNode
  showError?: boolean;
}

export const WhiteLabelHomeLayout = (props: LayoutProps) => {
  const { children } = props;

  return (
    <div className={styles.WhiteLabelHomeLayout}>
      <section className={styles.WhiteLabelContentContainer}>
        {children}
      </section>
      <Footer />
    </div>
  );
};

export const WhiteLabelLayout = (props: LayoutProps) => {
  const { children } = props;

  return (
    <div className={styles.WhiteLabelLayout}>
      <Navbar />
      <section className={styles.WhiteLabelContentContainer}>
        {children}
      </section>
      <Footer />
    </div>
  );
};

export const WhiteLabelResultsLayout = (props: LayoutProps) => {
  const { children, showError } = props;

  return (
    <div>
      <Navbar />
      <FindBestPriceActionBar />
      {showError ? <ErrorSection /> : <section className={styles.WhiteLabelResultsContentContainer}>{children}</section>}
      <Footer />
    </div>
  );
};
